export enum DocExtension {
  'HTML' = '.html',
  'PDF' = '.pdf',
  'TIF' = '.tif',
  'TIFF' = '.tiff',
  'INVOICE' = '.pdf',
  'VIDEO_LINK' = '',
}
